/* ============================================================================
   Size‑Guide Fullscreen Modal helper
   – Works for every modal rendered with data‑size-guide-modal attributes
   – No jQuery required
   – Adds body.sgm-open to lock background scroll
   ========================================================================== */
(function () {
  function initModal(modal) {
    if (modal.dataset.sgmInit) return;            // run once
    modal.dataset.sgmInit = '1';

    // move to <body> so parents don’t clip it
    document.body.appendChild(modal);

    var dialog  = modal.querySelector('.size-guide-modal__dialog');
    var opener  = document.querySelector(
      '[data-size-guide-modal-open="' + modal.id + '"]'
    );
    var closer  = modal.querySelector('[data-size-guide-modal-close]');
    var overlay = modal.querySelector('[data-size-guide-modal-close-overlay]');
    var lastFocus;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-active');
      document.body.classList.add('sgm-open');
      // focus dialog (for Esc key, accessibility)
      dialog && dialog.focus();
    }

    function close() {
      modal.classList.remove('is-active');
      modal.hidden = true;
      document.body.classList.remove('sgm-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    opener  && opener.addEventListener('click', open);
    closer  && closer.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-size-guide-modal]')
      .forEach(initModal);
  }

  /* initialise on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* if your theme swaps product info with AJAX (quick‑view, variant change, etc.)
     you can listen for Shopify Section re‑render events:
       document.addEventListener('shopify:section:load', initAll);
  */
})();